// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import moment from 'moment';
// import { saveAs } from 'file-saver';

// const ProfitAndLossStatement = () => {
//     const [loading, setLoading] = useState(false);
//     const [data, setData] = useState(null);
//     const [startDate, setStartDate] = useState('');
//     const [endDate, setEndDate] = useState('');

//     const [projects, setProjects] = useState([]);
//     const [selectedProject, setSelectedProject] = useState('');
//     const Api = process.env.REACT_APP_WEBZASH_URL;
//     const apiKey = process.env.REACT_APP_API_KEY;
//     const APIurl = process.env.REACT_APP_BACKEND_URL;

//     useEffect(() => {
//         fetchProjects();
//         fetchProfitLossData();
//     }, []);

//     const fetchProjects = async () => {
//         try {
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;
//             const response = await axios.get(`${APIurl}/api/projects`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,
//             });
//             setProjects(response.data);
//         } catch (error) {
//             console.error('Error fetching projects:', error);
//         }
//     };

//     const fetchProfitLossData = async () => {
//         setLoading(true);
//         try {
//             const params = {};
//             if (startDate) params.startdate = startDate;
//             if (endDate) params.enddate = endDate;
//             if (selectedProject) params.project_id = selectedProject;

//             const response = await axios.get(`${Api}/api/reports/profitloss`, {
//                 headers: {
//                     'x-api-key': apiKey,
//                     'Accept': 'application/json'
//                 },
//                 params
//             });

//             const processedData = processApiData(response.data.data);
//             setData(processedData);

//         } catch (error) {
//             console.error('Error fetching profit/loss data:', error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const processApiData = (apiData) => {
//         if (!apiData) return null;

//         const processItems = (items) => {
//             return items?.map(item => ({
//                 ...item,
//                 amount: parseFloat(item.amount) || 0,
//                 children: item.children ? processItems(item.children) : []
//             }));
//         };

//         return {
//             ...apiData,
//             gross_income_total: parseFloat(apiData.gross_income_total) || 0,
//             gross_expense_total: parseFloat(apiData.gross_expense_total) || 0,
//             gross_pl: parseFloat(apiData.gross_pl) || 0,
//             net_income_total: parseFloat(apiData.net_income_total) || 0,
//             net_expense_total: parseFloat(apiData.net_expense_total) || 0,
//             net_pl: parseFloat(apiData.net_pl) || 0,
//             gross_incomes: {
//                 ...apiData.gross_incomes,
//                 children: processItems(apiData.gross_incomes?.children || [])
//             },
//             gross_expenses: {
//                 ...apiData.gross_expenses,
//                 children: processItems(apiData.gross_expenses?.children || [])
//             },
//             net_incomes: {
//                 ...apiData.net_incomes,
//                 children: processItems(apiData.net_incomes?.children || [])
//             },
//             net_expenses: {
//                 ...apiData.net_expenses,
//                 children: processItems(apiData.net_expenses?.children || [])
//             }
//         };
//     };

//     const handleExport = async (format) => {
//         try {
//             const params = new URLSearchParams();
//             if (startDate) params.append('startdate', startDate);
//             if (endDate) params.append('enddate', endDate);
//             if (selectedProject !== '') params.append('project_id', selectedProject);
//             params.append('format', format);

//             const response = await axios.get(`${Api}/api/reports/profitloss?${params.toString()}`, {
//                 headers: {
//                     'x-api-key': apiKey,
//                     'Accept': 'application/octet-stream'

//                 },
//                 responseType: 'blob' // 👈 Important for binary file download
//             });

//             const contentDisposition = response.headers['content-disposition'];
//             let filename = `profitloss.${format}`;
//             if (contentDisposition && contentDisposition.includes('filename=')) {
//                 filename = contentDisposition
//                     .split('filename=')[1]
//                     .replace(/"/g, '')
//                     .trim();
//             }

//             const blob = new Blob([response.data], {
//                 type: format === 'csv'
//                     ? 'text/csv'
//                     : 'application/vnd.ms-excel'
//             });

//             saveAs(blob, filename);

//         } catch (error) {
//             console.error(`Error exporting report in ${format} format:`, error);
//         }
//     };
//     const handleClearFilters = () => {
//         setStartDate('');
//         setEndDate('');
//         setSelectedProject('');
//         fetchProfitLossData(); // Load unfiltered data
//     };


//     const renderAccountItem = (item, index) => {
//         const showDrAmount = item.cl_total_dc === 'D' && parseFloat(item.amount) > 0;
//         const showCrAmount = item.cl_total_dc === 'C' && parseFloat(item.amount) > 0;
//         return (
//             <div key={index} className={`account-item level-${item.level}`}>
//                 <div className="account-name">
//                     {item.level > 0 && <span className="bullet">•</span>}
//                     {item.name}
//                 </div>
//                 {/* <div className="account-amount">
//                     {item.amount?.toLocaleString('en-AE', {

//                         minimumFractionDigits: 2,
//                         maximumFractionDigits: 2
//                     })}
//                 </div> */}
//                 <div className="account-amount">
//                     {showDrAmount && `Dr ${Math.abs(item.amount).toLocaleString('en-AE', {
//                         minimumFractionDigits: 2,
//                         maximumFractionDigits: 2
//                     })}`}
//                     {showCrAmount && `Cr ${Math.abs(item.amount).toLocaleString('en-AE', {
//                         minimumFractionDigits: 2,
//                         maximumFractionDigits: 2
//                     })}`}
//                     {!showDrAmount && !showCrAmount && '0.00'}
//                 </div>
//             </div>
//         );
//     };

//     const renderAccountGroup = (items) => {
//         if (!Array.isArray(items)) return null;
//         return items.map((item, index) => (
//             <React.Fragment key={index}>
//                 {renderAccountItem(item, index)}
//                 {item.children && item.children.length > 0 && (
//                     <div className="account-children">
//                         {renderAccountGroup(item.children)}
//                     </div>
//                 )}
//             </React.Fragment>
//         ));
//     };


//     const renderTwoColumnSection = (
//         leftTitle,
//         leftItems,
//         leftLabel1,
//         leftAmount1,
//         leftLabel2,
//         leftAmount2,
//         leftTotal,
//         leftDc,

//         rightTitle,
//         rightItems,
//         rightLabel1,
//         rightAmount1,
//         rightLabel2,
//         rightAmount2,
//         rightTotal,
//         rightDc
//     ) => {
//         // const formatCurrency = (amount) => {
//         //     return new Intl.NumberFormat('en-AE', {
//         //         minimumFractionDigits: 2,
//         //         maximumFractionDigits: 2
//         //     }).format(amount);
//         // };
//         const formatCurrency = (amount, dc = 'D') => {
//             const absAmount = Math.abs(amount);
//             const formatted = new Intl.NumberFormat('en-AE', {
//                 minimumFractionDigits: 2,
//                 maximumFractionDigits: 2
//             }).format(absAmount);

//             return amount >= 0 ?
//                 (dc === 'D' ? `Dr ${formatted}` : `Cr ${formatted}`) :
//                 (dc === 'D' ? `Cr ${formatted}` : `Dr ${formatted}`);
//         };
//         return (
//             <div className="two-column-section">
//                 {/* Debit Side */}
//                 <div className="column debit-side">
//                     <h3 className="section-title">{leftTitle}</h3>
//                     <div className="account-group">{renderAccountGroup(leftItems)}</div>

//                     {/* Label Row 1 */}
//                     {leftLabel1 && (
//                         <div className="extra-item">
//                             <div className="account-name">{leftLabel1}</div>
//                             <div className="account-amount">{formatCurrency(leftAmount1,leftDc)}</div>
//                         </div>
//                     )}

//                     {/* Label Row 2 */}
//                     {leftLabel2 && (
//                         <div className="extra-item">
//                             <div className="account-name">{leftLabel2}</div>
//                             <div className="account-amount">{formatCurrency(leftAmount2,leftDc)}</div>
//                         </div>
//                     )}

//                     <div className="section-total">
//                         <span>Total</span>
//                         <span className="total-amount">{formatCurrency(leftTotal,leftDc)}</span>
//                     </div>
//                 </div>

//                 {/* Credit Side */}
//                 <div className="column credit-side">
//                     <h3 className="section-title">{rightTitle}</h3>
//                     <div className="account-group">{renderAccountGroup(rightItems)}</div>

//                     {/* Label Row 1 */}
//                     {rightLabel1 && (
//                         <div className="extra-item">
//                             <div className="account-name">{rightLabel1}</div>
//                             <div className="account-amount">{formatCurrency(rightAmount1,rightDc)}</div>
//                         </div>
//                     )}

//                     {/* Label Row 2 */}
//                     {rightLabel2 && (
//                         <div className="extra-item">
//                             <div className="account-name">{rightLabel2}</div>
//                             <div className="account-amount">{formatCurrency(rightAmount2,rightDc)}</div>
//                         </div>
//                     )}

//                     <div className="section-total">
//                         <span>Total</span>
//                         <span className="total-amount">{formatCurrency(rightTotal,rightDc)}</span>
//                     </div>
//                 </div>
//             </div>
//         );
//     };


//     const renderProfitSection = (title, amount, isTotal = false) => {
//         const isProfit = amount >= 0;
//         return (
//             <div className={`profit-section ${isProfit ? 'profit' : 'loss'} ${isTotal ? 'total' : ''}`}>
//                 <h3>{title}</h3>
//                 <div className="profit-amount">
//                     {/* {Math.abs(amount)?.toLocaleString('en-AE', {
//                         minimumFractionDigits: 2,
//                         maximumFractionDigits: 2
//                     })} */}
//                      {isProfit ? `Cr ${Math.abs(amount).toLocaleString('en-AE', {
//                     minimumFractionDigits: 2,
//                     maximumFractionDigits: 2
//                 })}` : `Dr ${Math.abs(amount).toLocaleString('en-AE', {
//                     minimumFractionDigits: 2,
//                     maximumFractionDigits: 2
//                 })}`}
//                     <span className="profit-label">
//                         ({isProfit ? 'Profit' : 'Loss'})
//                     </span>
//                 </div>
//             </div>
//         );
//     };

//     return (
//         <div className="main-content">
//             <div className="page-content">
//                 <div className="container-fluid">
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//                                 <h4 className="mb-sm-0 font-size-18">Profit and Loss Statement</h4>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="profit-loss-container">
//                         <div className="report-header">
//                             <h1>Profit and Loss Statement</h1>
//                             <div className="report-period">
//                                 {moment(startDate).format('MMM D, YYYY')} - {moment(endDate).format('MMM D, YYYY')}
//                                 {selectedProject && (
//                                     <span className="project-name">
//                                         • {projects.find(p => p.id === selectedProject)?.name || 'All Projects'}
//                                     </span>
//                                 )}
//                             </div>
//                             <div className="report-actions">
//                                 {/* <button className="action-btn" onClick={() => handleExport('print')}>
//                                     <i className="fas fa-print"></i> Print
//                                 </button> */}
//                                 <button className="action-btn" onClick={() => handleExport('csv')}>
//                                     <i className="fas fa-file-csv"></i> CSV
//                                 </button>
//                                 <button className="action-btn" onClick={() => handleExport('xls')}>
//                                     <i className="fas fa-file-excel"></i> Excel
//                                 </button>
//                             </div>
//                         </div>

//                         <div className="report-filters">
//                             <div className="filter-group">
//                                 <label>From</label>
//                                 <input
//                                     type="date"
//                                     value={startDate}
//                                     onChange={(e) => setStartDate(e.target.value)}
//                                     className="date-input"
//                                 />
//                             </div>
//                             <div className="filter-group">
//                                 <label>To</label>
//                                 <input
//                                     type="date"
//                                     value={endDate}
//                                     onChange={(e) => setEndDate(e.target.value)}
//                                     className="date-input"
//                                 />
//                             </div>
//                             {/* <div className="filter-group">
//                                 <label>Project</label>
//                                 <select
//                                     value={selectedProject}
//                                     onChange={(e) => setSelectedProject(e.target.value)}
//                                     className="select-input"
//                                 >
//                                     <option value="">All Projects</option>
//                                     {projects.map(project => (
//                                         <option key={project.id} value={project.id}>
//                                             {project.name}
//                                         </option>
//                                     ))}
//                                 </select>
//                             </div> */}
//                             <button
//                                 className="refresh-btn me-2"
//                                 onClick={fetchProfitLossData}
//                                 disabled={loading}
//                             >
//                                 {loading ? 'Refreshing...' : 'Apply Filters'}
//                             </button>

//                             <button
//                                 className="btn btn-secondary clear-btn"
//                                 onClick={handleClearFilters}
//                                 disabled={loading}
//                             >
//                                 Clear Filters
//                             </button>

//                         </div>

//                         {loading && !data ? (
//                             <div className="loading-state">
//                                 <div className="spinner"></div>
//                                 <p>Loading report data...</p>
//                             </div>
//                         ) : data ? (
//                             <div className="report-content">
//                                 {/* Gross Section - Two Columns */}
//                                 {renderTwoColumnSection(
//                                     // Left (Gross Expenses)
//                                     'Gross Expenses',
//                                     data.gross_expenses.children || [],
//                                     'Total Gross Expenses',
//                                     data.gross_expense_total,
//                                     data.gross_pl > 0 ? 'Gross Profit C/D' : null,
//                                     data.gross_pl > 0 ? data.gross_pl : null,
//                                     data.gross_expense_side_total,
//                                     'D',

//                                     // Right (Gross Income)
//                                     'Gross Income',
//                                     data.gross_incomes.children || [],
//                                     'Total Gross Incomes',
//                                     data.gross_income_total,
//                                     null,
//                                     null,
//                                     data.gross_income_side_total,
//                                     'C',
//                                 )}


//                                 {/* Gross Profit Row */}
//                                 {renderProfitSection('Gross Profit/Loss', data.gross_pl)}

//                                 {/* Net Section - Two Columns */}
//                                 {renderTwoColumnSection(
//                                     // Left (Net Expenses)
//                                     'Net Expenses',
//                                     data.net_expenses.children || [],
//                                     'Total Expenses',
//                                     data.net_expense_total,
//                                     'Net Profit',
//                                     data.net_pl,
//                                     data.net_expense_side_total,
//                                     'D',

//                                     // Right (Net Incomes)
//                                     'Net Income',
//                                     data.net_incomes.children || [],
//                                     'Total Incomes',
//                                     data.net_income_total,
//                                     data.gross_pl > 0 ? 'Gross Profit B/D' : null,
//                                     data.gross_pl > 0 ? data.gross_pl : null,
//                                     data.net_income_side_total,
//                                     'C',
//                                 )}


//                                 {/* Net Profit Row */}
//                                 {renderProfitSection('Net Profit/Loss', data.net_pl, true)}
//                             </div>
//                         ) : (
//                             <div className="empty-state">
//                                 <p>No report data available for the selected period</p>
//                             </div>
//                         )}

//                         <div className="report-footer">
//                             <p>Report generated on {moment().format('MMMM D, YYYY [at] h:mm A')}</p>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default ProfitAndLossStatement;



import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment';
import { saveAs } from 'file-saver';
import "react-datepicker/dist/react-datepicker.css";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import LedgerDetailsOffcanvas from './LedgerDetailsOffcanvas';

const ProfitAndLossStatement = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [showDrilldown, setShowDrilldown] = useState(false);
    const [selectedLedger, setSelectedLedger] = useState(null);

    const [projects, setProjects] = useState([]);
    const [selectedProject, setSelectedProject] = useState('');
    const Api = process.env.REACT_APP_WEBZASH_URL;
    const apiKey = process.env.REACT_APP_API_KEY;
    const APIurl = process.env.REACT_APP_BACKEND_URL;
    const getDayjsDate = (dateString) => {
        return dateString ? dayjs(dateString) : null;
    };

    useEffect(() => {
        fetchProjects();
        fetchProfitLossData();
    }, []);

    const fetchProjects = async () => {
        try {
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            const response = await axios.get(`${APIurl}/api/projects`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });
            setProjects(response.data?.Data);
        } catch (error) {
            console.error('Error fetching projects:', error);
        }
    };

    const fetchProfitLossData = async () => {
        setLoading(true);
        try {
            const params = {};
            if (startDate) params.startdate = startDate;
            if (endDate) params.enddate = endDate;
            if (selectedProject) params.project_id = selectedProject;

            const response = await axios.get(`${Api}/api/reports/profitloss`, {
                headers: {
                    'x-api-key': apiKey,
                    'Accept': 'application/json'
                },
                params
            });

            const processedData = processApiData(response.data.data);
            setData(processedData);

        } catch (error) {
            console.error('Error fetching profit/loss data:', error);
        } finally {
            setLoading(false);
        }
    };

    const processApiData = (apiData) => {
        if (!apiData) return null;

        const processItems = (items) => {
            return items?.map(item => ({
                ...item,
                amount: parseFloat(item.amount) || 0,
                is_group: item.children && item.children.length > 0,
                children: item.children ? processItems(item.children) : []
            }));
        };
        return {
            ...apiData,
            gross_income_total: parseFloat(apiData.gross_income_total) || 0,
            gross_expense_total: parseFloat(apiData.gross_expense_total) || 0,
            gross_pl: parseFloat(apiData.gross_pl) || 0,
            net_income_total: parseFloat(apiData.net_income_total) || 0,
            net_expense_total: parseFloat(apiData.net_expense_total) || 0,
            net_pl: parseFloat(apiData.net_pl) || 0,
            gross_incomes: {
                ...apiData.gross_incomes,
                children: processItems(apiData.gross_incomes?.children || [])
            },
            gross_expenses: {
                ...apiData.gross_expenses,
                children: processItems(apiData.gross_expenses?.children || [])
            },
            net_incomes: {
                ...apiData.net_incomes,
                children: processItems(apiData.net_incomes?.children || [])
            },
            net_expenses: {
                ...apiData.net_expenses,
                children: processItems(apiData.net_expenses?.children || [])
            }
        };
    };

    const handleExport = async (format) => {
        try {
            if (format === 'pdf') {
                // Call local backend for PDF export
                const userInfo = JSON.parse(localStorage.getItem('user-info'));
                const origin = localStorage.getItem('user-origin');
                const token = userInfo?.token;

                const params = {
                    startdate: startDate,
                    enddate: endDate
                };
                if (selectedProject) params.project_id = selectedProject;

                const response = await axios.get(`${APIurl}/api/profitloss/export-pdf`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Tenant-Origin': origin,
                        'Accept': 'application/pdf'
                    },
                    params,
                    responseType: 'blob'
                });

                const blob = new Blob([response.data], { type: 'application/pdf' });
                saveAs(blob, `ProfitAndLoss_${startDate || 'All'}_to_${endDate || 'All'}.pdf`);
            } else {
                // CSV/Excel export via Webzash
                const params = new URLSearchParams();
                if (startDate) params.append('startdate', startDate);
                if (endDate) params.append('enddate', endDate);
                if (selectedProject !== '') params.append('project_id', selectedProject);
                params.append('format', format);

                const response = await axios.get(`${Api}/api/reports/profitloss?${params.toString()}`, {
                    headers: {
                        'x-api-key': apiKey,
                        'Accept': 'application/octet-stream'
                    },
                    responseType: 'blob'
                });

                const contentDisposition = response.headers['content-disposition'];
                let filename = `profitloss.${format}`;
                if (contentDisposition && contentDisposition.includes('filename=')) {
                    filename = contentDisposition
                        .split('filename=')[1]
                        .replace(/"/g, '')
                        .trim();
                }

                const blob = new Blob([response.data], {
                    type: format === 'csv' ? 'text/csv' : 'application/vnd.ms-excel'
                });

                saveAs(blob, filename);
            }
        } catch (error) {
            console.error(`Error exporting report in ${format} format:`, error);
        }
    };
    const handleClearFilters = () => {
        setStartDate('');
        setEndDate('');
        setSelectedProject('');
        fetchProfitLossData();
    };


    const renderAccountItem = (item, index, type) => {
        const isGroup = item.children && item.children.length > 0;
        const showDrAmount = item.cl_total_dc === 'D' && parseFloat(item.amount) > 0;
        const showCrAmount = item.cl_total_dc === 'C' && parseFloat(item.amount) > 0;

        return (
            <div
                key={index}
                className={`account-item level-${item.level} ${isGroup ? 'group-row' : 'ledger-row cursor-pointer clickable-item'}`}
                onClick={() => {
                    if (!isGroup) {
                        setSelectedLedger({ ...item, type, is_group: isGroup });
                        setShowDrilldown(true);
                    }
                }}
            >
                <div className="account-name d-flex align-items-center">
                    {isGroup ? (
                        <i className="fas fa-chevron-down text-muted me-2" style={{ fontSize: '0.7rem' }}></i>
                    ) : (
                        <i className="fas fa-square text-primary me-2" style={{ fontSize: '0.35rem', opacity: 0.5, marginLeft: '4px' }}></i>
                    )}
                    <span className={isGroup ? 'fw-bold text-dark' : 'text-secondary'}>{item.name}</span>
                    <i className="fas fa-search-plus ms-2 drilldown-icon" title="Click to view details" style={{ fontSize: '0.6rem' }}></i>
                </div>
                <div className={`account-amount ${isGroup ? 'fw-bold text-dark' : 'text-dark'}`}>
                    {showDrAmount && `Dr ${Math.abs(item.amount).toLocaleString('en-AE', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}`}
                    {showCrAmount && `Cr ${Math.abs(item.amount).toLocaleString('en-AE', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}`}
                    {!showDrAmount && !showCrAmount && '0.00'}
                </div>
            </div>
        );
    };

    const renderAccountGroup = (items, type) => {
        if (!Array.isArray(items)) return null;
        return items.map((item, index) => {
            const isGroup = item.children && item.children.length > 0;
            return (
                <div key={index} className="account-row-wrapper">
                    {renderAccountItem(item, index, type)}
                    {isGroup && (
                        <div className="account-children ps-3 border-start ms-2 mb-2">
                            {renderAccountGroup(item.children, type)}
                        </div>
                    )}
                </div>
            );
        });
    };


    const renderTwoColumnSection = (
        leftTitle,
        leftItems,
        leftLabel1,
        leftAmount1,
        leftLabel2,
        leftAmount2,
        leftTotal,
        leftDc,

        rightTitle,
        rightItems,
        rightLabel1,
        rightAmount1,
        rightLabel2,
        rightAmount2,
        rightTotal,
        rightDc
    ) => {
        const formatCurrency = (amount, dc = 'D') => {
            const absAmount = Math.abs(amount);
            const formatted = new Intl.NumberFormat('en-AE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(absAmount);

            return amount >= 0 ?
                (dc === 'D' ? `Dr ${formatted}` : `Cr ${formatted}`) :
                (dc === 'D' ? `Cr ${formatted}` : `Dr ${formatted}`);
        };

        return (
            <div className="two-column-section">
                <div className="column debit-side">
                    <h4 className="section-title">{leftTitle}</h4>
                    <div className="account-group">{renderAccountGroup(leftItems, 'expense')}</div>

                    {leftLabel1 && (
                        <div className="extra-item">
                            <div className="account-name">{leftLabel1}</div>
                            <div className="account-amount">{formatCurrency(leftAmount1, leftDc)}</div>
                        </div>
                    )}

                    {leftLabel2 && (
                        <div className="extra-item">
                            <div className="account-name">{leftLabel2}</div>
                            <div className="account-amount">{formatCurrency(leftAmount2, leftDc)}</div>
                        </div>
                    )}

                    <div className="section-total">
                        <strong>Total</strong>
                        <strong className="total-amount">{formatCurrency(leftTotal, leftDc)}</strong>
                    </div>
                </div>

                <div className="column credit-side">
                    <h4 className="section-title">{rightTitle}</h4>
                    <div className="account-group">{renderAccountGroup(rightItems, 'income')}</div>

                    {rightLabel1 && (
                        <div className="extra-item">
                            <div className="account-name">{rightLabel1}</div>
                            <div className="account-amount">{formatCurrency(rightAmount1, rightDc)}</div>
                        </div>
                    )}

                    {rightLabel2 && (
                        <div className="extra-item">
                            <div className="account-name">{rightLabel2}</div>
                            <div className="account-amount">{formatCurrency(rightAmount2, rightDc)}</div>
                        </div>
                    )}

                    <div className="section-total">
                        <strong>Total</strong>
                        <strong className="total-amount">{formatCurrency(rightTotal, rightDc)}</strong>
                    </div>
                </div>
            </div>
        );
    };


    const renderProfitSection = (title, amount, isTotal = false) => {
        const isProfit = amount >= 0;
        return (
            <div className={`profit-section ${isProfit ? 'profit' : 'loss'} ${isTotal ? 'total' : ''}`}>
                <h5>{title}</h5>
                <div className="profit-amount">
                    {isProfit ? `Cr ${Math.abs(amount).toLocaleString('en-AE', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}` : `Dr ${Math.abs(amount).toLocaleString('en-AE', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}`}
                    <span className="profit-label">
                        ({isProfit ? 'Profit' : 'Loss'})
                    </span>
                </div>
            </div>
        );
    };

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    {/* Compact Header */}
                    <div className="row mb-3">
                        <div className="col-12">
                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                    <h4 className="mb-0">Profit and Loss Statement</h4>
                                    <small className="text-muted">
                                        {startDate ? moment(startDate).format('MMM D, YYYY') : ''}
                                        {endDate ? ` - ${moment(endDate).format('MMM D, YYYY')}` : ''}
                                        {selectedProject && (
                                            <span className="ms-2">
                                                • {projects.find(p => p.id === selectedProject)?.name || 'All Projects'}
                                            </span>
                                        )}
                                    </small>
                                </div>
                                <div className="d-flex gap-1">
                                    <button className="btn btn-sm btn-outline-danger" onClick={() => handleExport('pdf')}>
                                        <i className="fas fa-file-pdf"></i>
                                    </button>

                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Compact Filters */}
                    <div className="row mb-3">
                        <div className="col-12">
                            <div className="d-flex gap-2 flex-wrap align-items-end">
                                <div className="flex-fill" style={{ minWidth: '150px' }}>
                                    <label className="form-label small mb-1">From</label>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            views={["year", "month", "day"]}
                                            format="DD-MM-YYYY"
                                            value={getDayjsDate(startDate)}
                                            onChange={(newValue) => {
                                                setStartDate(newValue ? newValue.format('YYYY-MM-DD') : '');
                                            }}
                                            slotProps={{
                                                textField: { size: "small", fullWidth: true },
                                                popper: { sx: { "& .MuiPaper-root": { fontSize: "0.7rem", minWidth: 260 } } },
                                            }}
                                        />
                                    </LocalizationProvider>
                                </div>
                                <div className="flex-fill" style={{ minWidth: '150px' }}>
                                    <label className="form-label small mb-1">To</label>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>

                                        <DatePicker
                                            views={["year", "month", "day"]}
                                            format="DD-MM-YYYY"
                                            value={getDayjsDate(endDate)}
                                            onChange={(newValue) => {
                                                setEndDate(newValue ? newValue.format('YYYY-MM-DD') : '');
                                            }}
                                            slotProps={{
                                                textField: { size: "small", fullWidth: true },
                                                popper: { sx: { "& .MuiPaper-root": { fontSize: "0.7rem", minWidth: 160 } } },
                                            }}
                                        />
                                    </LocalizationProvider>
                                </div>
                                <div className="flex-fill" style={{ minWidth: '150px' }}>
                                    <label className="form-label small mb-1">Project</label>
                                    <select
                                        value={selectedProject}
                                        onChange={(e) => setSelectedProject(e.target.value)}
                                        className="form-select form-select-sm"
                                    >
                                        <option value="">All Projects</option>
                                        {projects.map(project => (
                                            <option key={project.id} value={project.id}>
                                                {project.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="d-flex gap-1">
                                    <button
                                        className="btn btn-primary btn-sm"
                                        onClick={fetchProfitLossData}
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <span className="spinner-border spinner-border-sm me-1"></span>
                                        ) : 'Apply'}
                                    </button>
                                    <button
                                        className="btn btn-outline-secondary btn-sm"
                                        onClick={handleClearFilters}
                                        disabled={loading}
                                    >
                                        Clear
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Main Report Content - Made more compact */}
                    <div className="row">
                        <div className="col-12">
                            <div className="profit-loss-container">
                                {loading && !data ? (
                                    <div className="text-center py-3">
                                        <div className="spinner-border spinner-border-sm text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <p className="mt-2 small">Loading report data...</p>
                                    </div>
                                ) : data ? (
                                    <div className="report-content">
                                        {/* Gross Section */}
                                        {renderTwoColumnSection(
                                            'Gross Expenses',
                                            data.gross_expenses.children || [],
                                            'Total Gross Expenses',
                                            data.gross_expense_total,
                                            data.gross_pl > 0 ? 'Gross Profit C/D' : null,
                                            data.gross_pl > 0 ? data.gross_pl : null,
                                            data.gross_expense_side_total,
                                            'D',
                                            'Gross Income',
                                            data.gross_incomes.children || [],
                                            'Total Gross Incomes',
                                            data.gross_income_total,
                                            null,
                                            null,
                                            data.gross_income_side_total,
                                            'C',
                                        )}

                                        {/* Gross Profit Row */}
                                        {renderProfitSection('Gross Profit/Loss', data.gross_pl)}

                                        {/* Net Section */}
                                        {renderTwoColumnSection(
                                            'Net Expenses',
                                            data.net_expenses.children || [],
                                            'Total Expenses',
                                            data.net_expense_total,
                                            'Net Profit',
                                            data.net_pl,
                                            data.net_expense_side_total,
                                            'D',
                                            'Net Income',
                                            data.net_incomes.children || [],
                                            'Total Incomes',
                                            data.net_income_total,
                                            data.gross_pl > 0 ? 'Gross Profit B/D' : null,
                                            data.gross_pl > 0 ? data.gross_pl : null,
                                            data.net_income_side_total,
                                            'C',
                                        )}

                                        {/* Net Profit Row */}
                                        {renderProfitSection('Net Profit/Loss', data.net_pl, true)}
                                    </div>
                                ) : (
                                    <div className="text-center py-3">
                                        <p className="text-muted small">No report data available for the selected period</p>
                                    </div>
                                )}

                                {/* Compact Footer */}
                                <div className="report-footer text-muted small text-center mt-3">
                                    Report generated on {moment().format('MMM D, YYYY h:mm A')}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add this CSS */}
            <style jsx>{`
                .profit-loss-container {
                    background: white;
                    border-radius: 8px;
                    padding: 20px;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                }
                
                .two-column-section {
                    display: flex;
                    gap: 15px;
                    margin-bottom: 15px;
                }
                
                .column {
                    flex: 1;
                    border: 1px solid #dee2e6;
                    border-radius: 6px;
                    padding: 12px;
                    background: #f8f9fa;
                }
                
                .section-title {
                    font-size: 0.9rem;
                    font-weight: 600;
                    color: #495057;
                    margin-bottom: 8px;
                    padding-bottom: 4px;
                    border-bottom: 1px solid #dee2e6;
                }
                
                .account-item {
                    display: flex;
                    justify-content: space-between;
                    padding: 2px 0;
                    font-size: 0.8rem;
                }
                
                .account-item.level-0 {
                    margin-top: 4px;
                }
                
                .account-item.level-1 {
                    /* Indentation handled by container */
                }
                
                .account-item.level-2 {
                    /* Indentation handled by container */
                }

                .group-row {
                    background-color: rgba(0,0,0,0.02);
                    border-radius: 4px;
                    padding-left: 4px !important;
                    padding-right: 4px !important;
                }

                .ledger-row:hover {
                    background-color: rgba(52, 110, 235, 0.03);
                }
                
                .account-name {
                    flex: 1;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    color: #6c757d;
                }
                
                .account-amount {
                    font-size: 0.8rem;
                    color: #212529;
                    min-width: 90px;
                    text-align: right;
                }
                
                .extra-item {
                    display: flex;
                    justify-content: space-between;
                    padding: 3px 0;
                    margin-top: 2px;
                    border-top: 1px dashed #dee2e6;
                    font-size: 0.85rem;
                }
                
                .section-total {
                    display: flex;
                    justify-content: space-between;
                    padding: 6px 0;
                    margin-top: 6px;
                    border-top: 2px solid #495057;
                    font-size: 0.85rem;
                }
                
                .profit-section {
                    margin: 10px 0;
                    padding: 8px;
                    border-radius: 6px;
                    text-align: center;
                }
                
                .profit-section.profit {
                    background: #d1e7dd;
                    border: 1px solid #badbcc;
                }
                
                .profit-section.loss {
                    background: #f8d7da;
                    border: 1px solid #f5c2c7;
                }
                
                .profit-section.total {
                    background: #cfe2ff;
                    border: 1px solid #b6d4fe;
                    margin: 15px 0;
                }
                
                .profit-section h5 {
                    margin: 0;
                    font-size: 0.9rem;
                    color: #495057;
                }
                
                .profit-amount {
                    font-weight: 600;
                    font-size: 0.9rem;
                    margin-top: 4px;
                }
                
                .profit-label {
                    font-size: 0.75rem;
                    margin-left: 6px;
                    color: #6c757d;
                }
                
                .report-footer {
                    padding-top: 10px;
                    border-top: 1px solid #dee2e6;
                }
                
                /* Reduce vertical space */
                .account-children {
                    margin-bottom: 2px;
                }
                
                .bullet {
                    margin-right: 4px;
                }
                
                .clickable-item {
                    cursor: pointer;
                    transition: background-color 0.2s;
                }
                
                .clickable-item:hover {
                    background-color: rgba(52, 110, 235, 0.05);
                }
                
                .drilldown-icon {
                    font-size: 0.7rem;
                    color: #adb5bd;
                    opacity: 0;
                    transition: opacity 0.2s;
                }
                
                .clickable-item:hover .drilldown-icon {
                    opacity: 1;
                }
            `}</style>

            {showDrilldown && selectedLedger && (
                <LedgerDetailsOffcanvas
                    show={showDrilldown}
                    onHide={() => {
                        setShowDrilldown(false);
                        setSelectedLedger(null);
                    }}
                    ledger={selectedLedger}
                    startDate={startDate}
                    endDate={endDate}
                    projectId={selectedProject}
                />
            )}
        </div>
    );
};

export default ProfitAndLossStatement;